import defaults from './i18n.json';

export const defaultTranslations = defaults;

export const stateKeys = Object.freeze({
  MESSAGES: 'messages',
  LOCALE: 'locale',
});

export default stateKeys;
